import { render, staticRenderFns } from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=template&id=7962105a&scoped=true"
import script from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=style&index=0&id=7962105a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7962105a",
  null
  
)

export default component.exports